(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var languageToggle = document.getElementById('myrLangToggle');
  if (languageToggle) {
    languageToggle.addEventListener('click', function () {
      var arabic = !document.body.classList.contains('myr-lang-ar');
      document.body.classList.toggle('myr-lang-ar', arabic);
      document.body.setAttribute('dir', arabic ? 'rtl' : 'ltr');
      document.documentElement.setAttribute('dir', arabic ? 'rtl' : 'ltr');
      document.documentElement.setAttribute('lang', arabic ? 'ar' : 'fr');
      languageToggle.textContent = arabic ? 'FR' : 'العربية';
    });
  }

  var gallery = document.getElementById('myrProductGallery');
  if (gallery) {
    var slides = Array.from(gallery.querySelectorAll('.myr-slide'));
    var thumbs = Array.from(gallery.querySelectorAll('.myr-thumb'));
    var counter = gallery.querySelector('.myr-gallery-count');
    var stage = gallery.querySelector('.myr-gallery-stage');
    var index = 0;
    var swipeStart = 0;
    var autoplay;
    var show = function (next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === index); });
      counter.textContent = (index + 1) + ' / ' + slides.length;
    };
    var restart = function () {
      clearInterval(autoplay);
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) autoplay = setInterval(function () { show(index + 1); }, 5000);
    };
    gallery.querySelector('.myr-prev').addEventListener('click', function () { show(index - 1); restart(); });
    gallery.querySelector('.myr-next').addEventListener('click', function () { show(index + 1); restart(); });
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { show(i); restart(); }); });
    stage.addEventListener('touchstart', function (event) { swipeStart = event.changedTouches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (event) { var distance = event.changedTouches[0].clientX - swipeStart; if (Math.abs(distance) > 45) { show(index + (distance < 0 ? 1 : -1)); restart(); } }, { passive: true });
    show(0); restart();
  }

  var productMainImage = document.querySelector('.myr-product-main-media img');
  document.querySelectorAll('.myr-product-media-item').forEach(function (thumb) {
    thumb.addEventListener('click', function (event) {
      if (!productMainImage) return;
      event.preventDefault();
      productMainImage.src = thumb.href;
      productMainImage.removeAttribute('srcset');
      document.querySelectorAll('.myr-product-media-item').forEach(function (item) { item.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  var buyButtons = document.querySelectorAll('.myr-buy-now');
  var linkedProductRoot = document.querySelector('[data-myr-product][data-product-url]');
  if (linkedProductRoot && linkedProductRoot.dataset.productUrl) {
    buyButtons.forEach(function (button) { button.disabled = false; });
  }
  buyButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var productRoot = button.closest('[data-myr-product]') || document.querySelector('[data-myr-product][data-product-url]');
      var productUrl = productRoot && productRoot.dataset.productUrl;
      if (!productUrl) {
        window.alert(document.body.classList.contains('myr-lang-ar') ? 'يرجى اختيار منتج MYR في إعدادات القسم.' : 'Sélectionnez le produit MYR dans les réglages de la section.');
        return;
      }
      window.location.href = productUrl;
    });
  });
}());
